import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './curve-theme.css';

type CaseSearchInputProps = {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onSearch?: () => void;
};

export function CaseSearchInput({
  placeholder,
  value,
  onChange,
  onSearch,
}: CaseSearchInputProps) {
  const { t } = useTranslation();
  const resolvedPlaceholder = placeholder ?? t('SearchBar.placeholder');
  const inputRef = useRef<HTMLInputElement>(null);
  const [focused, setFocused] = useState(false);

  return (
    <div
      onClick={() => inputRef.current?.focus()}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '0 10px',
        height: '34px',
        border: `1px solid ${focused ? 'var(--curve-primary, #22C55E)' : 'var(--curve-border, #E5E5E5)'}`,
        borderRadius: 'var(--curve-radius-md, 8px)',
        background: 'var(--curve-bg-white, #FFFFFF)',
        cursor: 'text',
        flex: 1,
        transition: 'border-color var(--curve-transition)',
        boxSizing: 'border-box',
      }}
    >
      <span style={{ fontSize: '13px', color: 'var(--curve-text-placeholder, #94A3B8)', flexShrink: 0 }}>
        🔍
      </span>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSearch?.();
          if (e.key === 'Escape') { onChange(''); inputRef.current?.blur(); }
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={resolvedPlaceholder}
        style={{
          flex: 1,
          border: 'none',
          outline: 'none',
          background: 'transparent',
          fontSize: 'var(--curve-text-small, 13px)',
          color: 'var(--curve-text-dark, #1E293B)',
          padding: 0,
          minWidth: 0,
        }}
      />
      {value && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onChange('');
            inputRef.current?.focus();
          }}
          className="curve-btn"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '16px',
            height: '16px',
            borderRadius: 'var(--curve-radius-pill, 9999px)',
            background: 'var(--curve-text-placeholder, #94A3B8)',
            color: 'var(--curve-text-on-primary, #FFFFFF)',
            fontSize: '10px',
            flexShrink: 0,
            lineHeight: 1,
          }}
        >
          ✕
        </button>
      )}
    </div>
  );
}
